import { useRouter } from 'next/router'
import { useState, useEffect } from 'react'
import Link from 'next/link'
import Head from 'next/head'
import dynamic from 'next/dynamic';

import { getPageData, getPost, getAllPosts, getCategoryPostsBlogDetail, getAllCategoriesNew, getReviewer } from '../../lib/api';
import RelatedArticles from '../../components/ui/relatedArticles';
import ProductCarouselM from '../../components/ui/ProductCarouselM';
import { formatDate, readTime, removeExcerpt, getWebsiteID } from '../../lib/common-functions';
import classes from '../../styles/blog-details.module.css';
import HighLight from '../../lib/getHighLights';
import { useCookies } from "react-cookie"
import { getReduxSession } from "../../lib/sessionHandler"
import { useSelector } from "react-redux";
import parse, { attributesToProps } from 'html-react-parser';
import { BlogPageInteraction } from '../../lib/ga'
import { EventCommonObj } from '../../lib/services/helpers/eventCommonObject'
import JsonLdBlog from '../../components/Schema/jsonLdBlog';
import share_icon from '~/public/images/share-grey-inline.svg';
import like_icon from '~/public/images/like-grey-inline.svg';
import like_icon_full2 from '~/public/images/like-icon-full2.inline.svg';
import { useIsMobile } from '/lib/hooks/useIsMobile';
import { generateBreadcrumbs } from '/lib/services/helpers/generateBreadCrumbs';
import { getBreadCrumbURL } from '/lib/services/helpers/getWebsiteURL';
import { useNotifyModal } from '/lib/hooks/useNotifyModal';
import { getRedirectionURL } from '/lib/services/helpers/getRedirectionURL';
 

const NotifyModal = dynamic(() => import('/components/NotifyModal'))

async function getProduct(filter, key, exp) {
	const response = await fetch(process.env.NEXTAUTH_URL + "/api/getproduct", {
		method: "POST",
		body: JSON.stringify({ filters: filter, key: key, exp: exp }),
		headers: {
			"Content-Type": "application/json",
		},
	});
	const data = await response.json();
	if (!response.ok) {
		return data;
	}
	return data;
}

export default function Post({ postData, allPosts, relatedPosts, categories, pageContent, reviewData }) {
	const router = useRouter();
	const menu = useSelector((state) => state.menu);
	const session = getReduxSession(false);
	pageContent = (pageContent && pageContent.pwa) ? pageContent.pwa : null
	const [likedIcon, setLikedIcon] = useState(like_icon);
	const [heroProductData, setheroProductData] = useState();

	 
	const blogSlug = router.query.slug || postData.slug
	const url = getRedirectionURL(blogSlug);

	const { showNotifyModal, handleModalClose } = useNotifyModal();

	let skulist = []
	let storeID = 1
	if (!postData) {
		return <p>Page Not found</p>;
	}
	if (!router.isFallback && !postData?.slug) {
		return <p>wrong page error</p>;
	}

	if (postData && postData.pwa_post && postData.pwa_post.relatedproducts) {
		skulist = (postData.pwa_post.relatedproducts).split(',')
	}
	useEffect(() => {
		const heroProduct = getProduct({ sku: { eq: pageContent.section3 } }, 'heroproduct', 86400 * 7);
		const response = async () => {
			try {
				const tmp = await heroProduct;
				if (tmp && tmp.data) {
					setheroProductData(tmp.data?.products?.items[0]);
				}
			} catch (error) {
				console.log('error', error);
			}
		};
		response();
	}, [pageContent.section3]);

	const [stickClass, setStickClass] = useState('');
	const [cookie, setCookie] = useCookies(["store"])
	let website_id = getWebsiteID(cookie);
	let prefixUrl = getBreadCrumbURL(website_id)
	const breadCrumbUrl = getBreadCrumbURL(website_id)

	let post_content = (postData.content) ? postData.content : '';
	const regexHighlights = /<h2\s*.*>\s*.*<\/h2>/g;
	const highLights = post_content.match(regexHighlights);
	{
		(highLights) ? (
			highLights.map(function (element, index) {
				const remove_html_regex = /(<([^>]+)>)/ig;
				const result = element.replace(remove_html_regex, '');

				post_content = post_content.replace(element, "<h2 id='highlight_" + index + "'>" + result + "</h2>");
			})
		) : null

	}
	const scrollHandler = () => {
		window.pageYOffset > 120 ? setStickClass('sticky_category') : setStickClass('')
	};

	const eventCommonObj = EventCommonObj(session, cookie)

	useEffect(() => {

		window.addEventListener('scroll', scrollHandler);
	}, []);
	const categoryUrlSuffix = ".html";

	const isMobileDevice = useIsMobile();
	function openShare() {
		BlogPageInteraction('share', postData.title, postData.slug, postData.author.node.name, eventCommonObj)
		const sharedText = (post_content.excerpt) ? removeExcerpt(post_content.excerpt) : post_content.title;
		navigator
			.share({
				title: post_content.title,
				text: sharedText,
				url: window.location.href
			})
			.then(() => console.log('Successful share! 🎉'))
			.catch(err => console.error(err));

	}

	async function likeUpdater(pid, feedback) {

		const res = await fetch("/api/blog-like", {
			body: JSON.stringify({ pid, feedback }),
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
		});
		const data = await res.json();
		// const data = await response.json();
		if (!res.ok) {
			return data;
		}
		return data;
	}

	function likehandler(feedback) {

		// e.preventDefault();
		// setButtonText("Please Wait")
		if (session && session.accessToken) {
			const result = likeUpdater(postData.databaseId, feedback);
			const response = async () => {
				try {
					const tmp = await result;
					BlogPageInteraction('like', postData.title, postData.slug, postData.author.node.name, eventCommonObj)
					setLikedIcon(like_icon_full2)
				} catch (error) {
					console.log('error', error);
				}
			};
			response();

		} else {
			router.push(prefixUrl + "customer/account/login")
		}

	}

	const readTimes = readTime(postData.content);

	const options = {
		replace: domNode => {
			if (domNode.attribs && domNode.name === 'img' && domNode.attribs.src && domNode.attribs.src.includes('wp-content/uploads/')) {
				let props = attributesToProps(domNode.attribs);
				let newString = props.src.split('wp-content/uploads/');
				if (newString && newString[1]) {
					props.src = process.env.WP_IMG_URL + newString[1]
					return <img {...props} />;
				}
			}
		}
	};

	return (
		<div>
			<Head>
				{(postData.seo.title) ? (<title>{postData.seo.title}</title>) : null}
				{(postData.seo.title) ? (<meta name="title" content={postData.seo.title} />) : null}
				{(postData.seo.metaDesc) ? (<meta name="description" content={postData.seo.metaDesc} />) : null}
				{(postData.pwa_post && postData.pwa_post.metaKeyword) ? (<meta name="keywords" content={postData.pwa_post.metaKeyword} />) : null}
				{(postData.seo.opengraphTitle) ? (<meta property="og:title" content={postData.seo.opengraphTitle} />) : null}
				{(postData.seo.opengraphDescription) ? (<meta property="og:description" content={postData.seo.opengraphDescription} />) : null}
				{(postData.seo.opengraphImage && postData.seo.opengraphImage.sourceUrl) ? (<meta property="og:image" content={postData.seo.opengraphImage.sourceUrl} />) : null}
				{(postData.seo.twitterDescription) ? (<meta property="twitter:description" content={postData.seo.twitterDescription} />) : null}
				{(postData.seo.twitterTitle) ? (<meta property="twitter:title" content={postData.seo.twitterTitle} />) : null}
			</Head>
			<JsonLdBlog data={postData} />
			{showNotifyModal ? <NotifyModal
				handleModalClose={handleModalClose}
				className='notifyContent'
				isOpen={showNotifyModal}
				redirectUrl={url?.redirectUrl || null}
				hreflangUrl={url?.hreflangUrl || null}
			/> : null}
			<div className={`ayurveda-sec1 ` + classes['blog-sec1']}>
				{menu?.length > 0 && (
					<div>
						{" "}
						{isMobileDevice && (
							<div>
								<div className={"category-product-menu" + " " + (stickClass ? stickClass : '')}>
									<ul>
										{/* <li><Link href={prefixUrl + "/kumkumadi-week-celebration.html"}><a><span className={"new"}>Offer</span>Kumkumadi Week</a></Link></li> */}
										{menu.map((topcategory) => (
											topcategory.url_path == 'free-trial' ?
												<li key={topcategory.id}>
													<Link
														href={topcategory.url_path}
														as={`${prefixUrl}/${topcategory.url_path}`}
														className={
															router.asPath ==
																`/${topcategory.url_path}`
																? "active"
																: ""
														}>

														{topcategory.name} {(topcategory && topcategory.category_tag) ? <span className={"new"}>{topcategory.category_tag}</span> : ''}

													</Link>
												</li> :
												<li key={topcategory.id}>
													<Link
														href={{
															pathname: "/_url-resolver",
															query: {
																pathname: `/${topcategory.url_path + categoryUrlSuffix
																	}`,
																type: "CATEGORY",
																url_path: topcategory.url_path,
																url_key: topcategory.url_key,
																cat_id: topcategory.id,
															},
														}}
														as={`${prefixUrl}/${topcategory.url_path + categoryUrlSuffix}`}
														className={
															router.asPath ==
																`/${topcategory.url_path + categoryUrlSuffix}`
																? "active"
																: ""
														}>

														{topcategory.name} {(topcategory && topcategory.category_tag) ? <span className={"new"}>{topcategory.category_tag}</span> : ''}

													</Link>
												</li>
										))}
										{/* { website_id == 1 && <li><Link href={prefixUrl + "/free-trial"}>Free trial</Link></li> } */}
										<li><Link href={prefixUrl + "/shop.html"}>All Products</Link></li>
										{/* { website_id == 1 && <li><Link href={prefixUrl + "/kama-anniversary"}><a> 20 years of kama</a></Link></li> } */}
									</ul>
								</div>
								<div className="sticky_category_margin"></div>
							</div>
						)}{" "}
					</div>
				)}
				<div>{isMobileDevice && <span>{(postData.featuredImage && postData.featuredImage.node.mediaDetails && postData.featuredImage.node.mediaDetails.file) ? <img loading="lazy" src={(postData.featuredImage && postData.featuredImage.node.mediaDetails && postData.featuredImage.node.mediaDetails.file) ? process.env.WP_IMG_URL + postData.featuredImage.node.mediaDetails.file : null} alt={postData.title} title={postData.title} width="auto" height="auto" className="d-block" /> : null}</span>}</div>
				<div>{!isMobileDevice && <span >{(postData.featuredImage && postData.featuredImage.node.mediaDetails && postData.featuredImage.node.mediaDetails.file) ? <div><img loading="lazy" src={(postData.pwa_post && postData.pwa_post.desktopCoverImage && postData.pwa_post.desktopCoverImage.mediaDetails && postData.pwa_post.desktopCoverImage.mediaDetails.file) ? process.env.WP_IMG_URL + postData.pwa_post.desktopCoverImage.mediaDetails.file : ((postData.featuredImage && postData.featuredImage.node.mediaDetails && postData.featuredImage.node.mediaDetails.file) ? process.env.WP_IMG_URL + postData.featuredImage.node.mediaDetails.file : null)} alt={postData.title} title={postData.title} width={1400} height="auto" className="d-block w-100" /></div> : null}</span>}</div>

				<div className="container">

					<div className={classes["ayurveda-sec1-row"]}>
						<div className="breadcrumbs_sec">
							<nav>
								<ol>
									{generateBreadcrumbs(router, breadCrumbUrl, false)?.map((list, id) => (
										<li key={id}><Link href={list.href}>{list.title}</Link></li>
									))}
								</ol>
							</nav>
						</div>
						<h1>{postData.title}</h1>
						<ul>
							<li><a onClick={(e) => likehandler('yes')} ><abbr><img loading="lazy" src={likedIcon.src} alt="like icon" width={28} height={28} /></abbr> Like</a></li>
							<li><a onClick={(e) => openShare()} ><abbr><img loading="lazy" src={share_icon.src} alt="share icon" width={28} height={28} /></abbr> Share</a></li>
						</ul>
					</div>
				</div>
			</div>
			<div className="container">
				<div className="row">
					<div className="col-12 col-md-8">
						<div className={classes["blog-sec2"]}>
							<div className={classes["blog-start"]}>
								{(postData.author && postData.author.node && postData.author.node.name) ? <div className={classes["h4blog-start"]}>Authored by : <Link href="#blogabout"> {postData.author.node.name}</Link></div> : null}

								<ul><li>{formatDate(postData.date)}</li> <li>{readTimes} mins read</li></ul>
							</div>
							<div className={classes["blog-end"]}>
								{
									(reviewData && reviewData.blog && reviewData.blog.reviewer && reviewData.blog.reviewer.name) ? (
										<div className={classes["h4blog-start"]}>Reviewed by : <Link href="#blogreviewer">{reviewData.blog.reviewer.name}</Link></div>
									) : null
								}
							</div>
						</div>


						<div>	{isMobileDevice && <div>	{
							(highLights) ? (
								<div className={classes["blog-sec3"]}>
									<div className={classes["h3blog-sec3"]}>Highlights</div>
									<HighLight content={highLights} />
								</div>
							) : null
						} </div>} </div>

						<div className={classes["blog-sec4"] + " blog-sec4-h2"}>{parse(post_content, options)}</div>

						<div id="blogabout"></div>
						<div className={classes["blog-sec6"]} id="about">
							<div className={classes["h2blog-sec6"]}>About the Author</div>
							<div className={classes["col"]}>
								{
									(reviewData && reviewData.blog && reviewData.blog.author && reviewData.blog.author.imageurl) ? <span><img loading="lazy" src={reviewData.blog.author.imageurl} alt={postData.author.node.name} title={postData.author.node.name} width={200} height="auto" /></span> : null
								}

								<div className={classes["h4blog-sec6"]}><strong>{postData.author.node.name}</strong> {(reviewData?.blog?.author?.qualification) ? reviewData.blog.author.qualification : null}</div>
								{!isMobileDevice && (<div><p>{postData.author.node.description}</p> <div id="blogreviewer"></div></div>)}
							</div>
							{isMobileDevice && (<div><p>{postData.author.node.description}</p><div id="blogreviewer"></div></div>)}
						</div>

						{
							(reviewData && reviewData.blog && reviewData.blog.reviewer && reviewData.blog.reviewer.id) ? (
								<div className={classes["blog_sec2_reviewer"]}>
									<div className={classes["h2blog_sec2_reviewer"]}>About the Reviewer</div>
									<div className={classes["col"]}>
										{
											(reviewData && reviewData.blog && reviewData.blog.reviewer && reviewData.blog.reviewer.imageurl) ?
												<span><img loading="lazy" src={reviewData.blog.reviewer.imageurl} alt={reviewData.blog.reviewer.name} title={reviewData.blog.reviewer.name} width={200} height="auto" /></span> :
												null
										}
										<div className={classes["h4blog_sec2_reviewer"]}> {reviewData.blog.reviewer.name} {(reviewData.blog.reviewer.qualification) ? reviewData.blog.reviewer.qualification : null}</div>
										{!isMobileDevice && (<p>{reviewData.blog.reviewer.description}</p>)}
									</div>
									{isMobileDevice && (<p>{reviewData.blog.reviewer.description}</p>)}
								</div>
							) : null
						}
					</div>
					{!isMobileDevice && <div className="col-12 col-md-4">
						<div>	{
							(highLights) ? (
								<div className={classes["blog-sec3"]}>
									<div className={classes["h3blog-sec3"]}>Highlights</div>
									<HighLight content={highLights} />
								</div>
							) : null
						} </div>
						<div>	{website_id == 1 && <div className={`blog_detail_sec_colm7 ` + classes['blog_detail_sec_colm7']}>
							<ProductCarouselM slug={postData?.slug} skulist={skulist} storeid={storeID} heading="Related Products" noSeeAll="1" />
						</div>
						} </div>

						{
							((categories && categories.length > 0) ? (
								<div className={classes["blog_detail_sec_colm8"]}>
									<div className={classes["h2blog_detail_sec_colm8"]}>Blog Categories</div>
									<ul>
										{
											categories.map(({ node }) => (
												<li key={"catlist_" + node.id}>
													<Link
														href={prefixUrl + "blog/category/[...slug]"}
														as={`${prefixUrl}blog/category/${(node.parent) ? node.parent.node.slug + "/" + node.slug : node.slug}`}
														key={node.id}
													>{node.name + ((node.count) ? "(" + node.count + ")" : '')}</Link>
												</li>
											))
										}
									</ul>
								</div>

							) : '')
						}

						{
							(heroProductData && heroProductData.name && website_id == 1) ? (
								<div className="blog_detail_sec_colm9">
									<span><img loading="lazy" src={heroProductData.small_image.url} alt={heroProductData.name} title={heroProductData.name} width={800} height="auto" /></span>
									<Link
										href={{
											pathname: "/_url-resolver",
											query: {
												pathname: `${heroProductData.url_key + ".html"}`,
												type: "PRODUCT",
												url_path: heroProductData.url_key,
												url_key: heroProductData.url_key
											},
										}}
										as={`${prefixUrl + heroProductData.url_key + ".html"}`}
									>{(pageContent && pageContent.section4) ? pageContent.section4 : "Shop " + heroProductData.name}</Link>
								</div>
							) : null
						}

					</div>}
				</div>

				<div>	{website_id == 1 && <div>	{isMobileDevice && (<div className='blog-related'> <ProductCarouselM slug={postData?.slug} skulist={skulist} storeid={storeID} heading="Related Products" noSeeAll="1" />
				</div>)} </div>} </div>
				<div className={classes["blog_detail_sec_colm10"]}>
					<RelatedArticles items={relatedPosts} heading='Related Posts' /></div>
				<RelatedArticles items={allPosts} heading='Recent Posts' />

				<div>	{isMobileDevice && <div className={classes["blog-sec7"]}>
					<div className={classes["h2blog-sec7"]}>Was this article helpful?</div>
					<div className={classes["col"]}>
						<ul>
							<li><a onClick={(e) => likehandler('no')}>No</a></li> <li><a onClick={(e) => likehandler('yes')}>Yes</a></li>
						</ul>
					</div>
				</div>} </div>

			</div>
		</div>
	);

}

export async function getStaticPaths() {
	// const allPosts = await getAllPostsWithSlug();
	// const paths = allPosts.edges.map(({ node }) => {
	// 	let pathArray = [];
	// 	pathArray = node.slug;
	// 	return {
	// 		params: {
	// 			slug: pathArray
	// 		}
	// 	}
	// });
	return {
		paths: [],
		fallback: 'blocking'
	};

}

export async function getStaticProps({ params }) {
	try {
		var data = await getPost(params.slug);
		var pageContent = await getPageData("blog");
		var reviewData = await getReviewer(params.slug);
		var allPostIds = []
		var allPosts = await getAllPosts();
		allPosts.edges.map(function (item, key) {
			allPostIds.push(item.node.databaseId)
		})

		var relatedPosts = []
		if (data && data.post && data.post.categories && data.post.categories.nodes && data.post.categories.nodes[0]) {
			relatedPosts = await getCategoryPostsBlogDetail(data.post.categories.nodes[0].name, allPostIds);
		}

		var categories = await getAllCategoriesNew();
	} catch (error) {
		return {
			notFound: true,
			revalidate: 600,
		};
	}
	return {
		props: {
			postData: ((data && data.post) ? data.post : []),
			allPosts,
			relatedPosts,
			categories,
			pageContent,
			reviewData
		},
		revalidate: 600
	};
}

